module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/social/googledrive-932c549dfed67de6a71f4ff5d34618ef.svg";